import { Dialog } from '@material-ui/core';
import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { ModalLayout } from '@/layout';
import { makeSelectIsMobileView } from '@/model/global/selectors';
import { Func } from '@/utils/ts';

export interface ClosableDialogProps {
  'data-test'?: string;
  onClose: Func;
  title?: ReactNode;
  visible: boolean;
  height?: number;
}

const selectIsMobile = makeSelectIsMobileView();

export const ClosableDialog: React.FC<ClosableDialogProps> = ({
  visible,
  onClose,
  title,
  height,
  children,
  'data-test': dataTest,
}) => {
  const isMobile = useSelector(selectIsMobile);
  return isMobile ? (
    <Dialog
      data-test={dataTest && `${dataTest}-dialog`}
      onClose={onClose}
      open={visible}
      fullScreen
      TransitionProps={{
        style: {
          alignItems: 'start',
        },
      }}
      PaperProps={{
        style: {
          borderTopLeftRadius: '12px',
          borderTopRightRadius: '12px',
          height: '80%',
          position: 'absolute',
          bottom: 0,
        },
      }}
    >
      <ModalLayout data-test={dataTest && `${dataTest}-layout`} height="unset" title={title} onClose={onClose}>
        {children}
      </ModalLayout>
    </Dialog>
  ) : (
    <Dialog
      data-test={dataTest && `${dataTest}-dialog`}
      onClose={onClose}
      open={visible}
      disableBackdropClick
      TransitionProps={{
        style: {
          alignItems: 'start',
        },
      }}
      PaperProps={{
        style: {
          overflow: 'inherit',
          backgroundColor: 'transparent',
          margin: 0,
        },
      }}
    >
      <ModalLayout data-test={dataTest && `${dataTest}-layout`} height={height} title={title} onClose={onClose}>
        {children}
      </ModalLayout>
    </Dialog>
  );
};

export default ClosableDialog;
